<!-- 测测 -->
<template>
  <div class="container">
    <!-- 趣味测评基础信息 -->
    <FunIntro v-if="type == 1" :type="type" :id="id"></FunIntro>
    <!-- 专业测评基础信息 -->
    <ProfessionalIntro
      v-if="type == 2"
      :type="type"
      :id="id"
    ></ProfessionalIntro>
    <router-view class></router-view>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import FunIntro from "./components/funIntro.vue";
import ProfessionalIntro from "./components/professionalIntro.vue";
import { setToken } from "@/utils/auth";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: { FunIntro, ProfessionalIntro },
  data() {
    // 这里存放数据
    return {
      type: 1, // 1：趣味测评 2：专业测评
      id: 4, // 开发用id=4，正式用id需传入
      // enjoymentShow: false, // 趣味测评展示
      // professionalShow: false, // 专业测评展示
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.token) {
      let token = this.$route.query.token;
      setToken("Bearer " + token);
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (this.$route.query.type) {
      this.type = Number(this.$route.query.type);
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
// @import url(); 引入公共css类
.btn {
  margin: 30px auto;
}
</style>
